import { render, staticRenderFns } from "./TableBudgetPersonnel.vue?vue&type=template&id=774c3be2&scoped=true"
import script from "./TableBudgetPersonnel.vue?vue&type=script&lang=js"
export * from "./TableBudgetPersonnel.vue?vue&type=script&lang=js"
import style0 from "./TableBudgetPersonnel.vue?vue&type=style&index=0&id=774c3be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c3be2",
  null
  
)

export default component.exports